import React from 'react';
import { useSelector } from 'react-redux';

import Divider from 'dpl/components/BreederProfile/mobile/components/shared/Divider';
import BreederProfileReviews from 'dpl/components/BreederProfile/mobile/components/reviews/BreederProfileReviews';

export default function BreederProfileReviewsSectionContainer() {
  const testimonialsCount = useSelector(
    ({ server }) => server.testimonialsCount
  );

  if (testimonialsCount === 0) return null;

  return (
    <div className="BreederProfileReviewsSectionContainer">
      <Divider className="mt4 mb8" />
      <BreederProfileReviews reviewsPerPage={3} navigateToTab />
    </div>
  );
}
